// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GroupStatusIcon__icon-a31210 {
  margin-inline-start: 4px;
}

.GroupStatusIcon__sent-ae1666,
.GroupStatusIcon__sent-ae1666 {
  fill: var(--base-120);
}

.GroupStatusIcon__failed-ae388b {
  color: var(--addition-50);
  fill: var(--danger-40);
}

.GroupStatusIcon__sending-ab4a5b {
  fill: var(--base-80);
}`, "",{"version":3,"sources":["webpack://./src/main/SidebarPanel/components/GroupListItem/GroupStatusIcon/GroupStatusIcon.style.m.css"],"names":[],"mappings":"AAAA;EACE,wBAAA;AACF;;AAEA;;EAEE,qBAAA;AACF;;AAEA;EACE,yBAAA;EACA,sBAAA;AACF;;AAEA;EACE,oBAAA;AACF","sourcesContent":[".icon {\n  margin-inline-start: 4px;\n}\n\n.sent,\n.sent {\n  fill: var(--base-120);\n}\n\n.failed {\n  color: var(--addition-50);\n  fill: var(--danger-40);\n}\n\n.sending {\n  fill: var(--base-80);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": `GroupStatusIcon__icon-a31210`,
	"sent": `GroupStatusIcon__sent-ae1666`,
	"failed": `GroupStatusIcon__failed-ae388b`,
	"sending": `GroupStatusIcon__sending-ab4a5b`
};
module.exports = ___CSS_LOADER_EXPORT___;
